<template>
  <div class="top">
    <div>
      <h4 class="bottom-align" style="grid-area: title; padding-bottom: 3px;">
        <a class="text-primary" href="#" @click="defaultView" title="Startseite">
          {{ remote.instanceName }}
          <!--Kassenbuch der Fachschaften der FH Aachen-->
        </a>
      </h4>
    </div>
    <div class="info-box bottom-align">
      <span style="padding-bottom: 3px; text-align: right;">Angemeldet als: {{ username }}<br>
      <!--Letzte Anmeldung: 2018-04-28 16:53--></span>
    </div>
    <div style="grid-area: icons">
      <a class="text-secondary" href="#" @click="management" title="Verwaltung">
        <i class="fas fa-cog fa-2x top-bar-icon" style="margin-right:0px"></i>
      </a>
      <a class="text-danger" href="#" @click="logout" title="Ausloggen">
        <i class="fas fa-sign-out-alt fa-2x top-bar-icon"></i>
      </a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'TopBar',
  props: {
    msg: String
  },
  data() {
    return {
      remote: 'Default'
    }
  },
  computed: {
    username: function() {
      try {
        var credentials = JSON.parse(localStorage.getItem('credentials'))
        return credentials.username
      } catch (TypeError) {
        return ""
      }
    }
  },
  methods: {
    loadData: function() {
      var credentials = JSON.parse(localStorage.getItem('credentials'))
      if (!credentials) {
        credentials = this.$store.state.credentials
      }
      
      axios({url: process.env.VUE_APP_ROOT_API, auth: credentials, method: 'get'})
      //axios.get(process.env.VUE_APP_ROOT_API)
      .then(response => {
        this.remote = response.data;
      })
      .catch(e => {
        this.remote = "Ooops: " + e
      })
    },
    logout: function() {
      this.$store.dispatch('logout')
    },
    management: function() {
      window.location.href = "management";
    },
    defaultView: function() {
      window.location.href = "/";
    }
  },
  beforeMount(){
    this.loadData()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
